import { TCommonError } from "@models/common";
import { TInventorySessionItem } from "@models/asset";
import { axiosInstance } from "./axiosInstance";
import { TAxiosResponse } from "types";

const inventorySessionApi = {
  /**
   * GET /api/v1/inventory/sessions — nguồn cho dropdown 年月 [3] của PC004.
   * Contract: vams_docs/Tasks/PC004/analyzing-be.md §2.2/§2.4.
   */
  getSessions: async () => {
    const url = "/api/v1/inventory/sessions";
    const response: TAxiosResponse<TInventorySessionItem[], TCommonError> =
      await axiosInstance.get(url);
    return response;
  },
};

export { inventorySessionApi };
